<template>
  <div class="card-box">
    <h4>{{ trans.get('image_verification.daily_work') }}</h4>
    <div class="pickers-wrapper">
      <div>
        <DatePicker v-model="date" />
      </div>
      <div>
        <DatePicker v-model="period.from" />
        <DatePicker class="pt-2" v-model="period.to" />
      </div>
    </div>
    <div class="chart-wrapper">
      <Line :data="chartData" :options="chartOptions" v-if="chartData" />
    </div>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
} from 'chart.js';
import DatePicker from '../Common/DatePicker.vue';

ChartJS.register(Title, Tooltip, CategoryScale, LinearScale, PointElement, LineElement);

export default {
  name: 'ImageVerificationInactive',
  components: { DatePicker, Line },
  data() {
    return {
      chartData: null,
      date: this.getCurrentDate(),
      period: {
        from: this.getCurrentDate(),
        to: this.getCurrentDate(),
      }
    };
  },
  computed: {
    chartOptions() {
      return {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {}
      };
    }
  },
  methods: {
    getData() {
      axios
        .get('/ajax/image-verification-logs', {
          params: {
            from: this.period.from,
            to: this.period.to,
          }
        })
        .then(response => {
          this.chartData = {
            labels: response.data.labels,
            datasets: [{
              data: response.data.data,
              fill: false,
              borderColor: '#47BC9D',
              tension: 0.1
            }]
          };
        })
        .catch(error => {
        });
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
  watch: {
    date(newVal) {
      this.period.from = newVal;
      this.period.to = newVal;
    },
    period: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.card-box {
  position: relative;
  height: 800px;
  max-height: 70dvh;
}

.chart-wrapper {
  height: calc(100% - 130px);
}

.pickers-wrapper {
  display: flex;
  justify-content: space-between;

  div {
    max-width: 350px;
  }
}
</style>
